import { useEffect } from "react";

export default function Disclaimer() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.id = "termly-jssdk";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="terms-container">
      <div
        name="termly-embed"
        data-id="b47f8a48-bf07-454e-9ac5-fd4bf6a65b66"
      ></div>
    </div>
  );
}
